import './blocks';

import Blockly from './Blockly';
export { Blockly }

const toolbox: string = require('raw!./toolbox.xml');
export { toolbox }

const initblocks: string = require('raw!./initblocks.xml');
export { initblocks }

import media from './media';
export { media }



/** WEBPACK FOOTER **
 ** ./src/blockly/index.ts
 **/